var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.417 415.418V97H90V379.234L293.417 415.418Z",
    fill: "#F66052"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M700.25 558.629V533.11L909 558.629V615L700.25 558.629Z",
    fill: "#F66052"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M891.477 412.751L813.767 428.749V549.107L891.477 561.296V412.751Z",
    fill: "#F66052"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M293.417 415.418V97H90V379.234L293.417 415.418Z",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M700.25 558.629V533.11L909 558.629V615L700.25 558.629Z",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M891.477 412.751L813.767 428.749V549.107L891.477 561.296V412.751Z",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL3);
export default __webpack_public_path__ + "static/media/l3.bc0a610126a8d5734398154831cc736a.svg";
export { ForwardRef as ReactComponent };